import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const FooterContainer = styled.footer<{ $mobileHidden: boolean }>(
  ({ theme, $mobileHidden }) => `
    background-color: ${theme.colors.grey.primary};
    margin-top: auto;
    display: ${$mobileHidden ? 'none' : 'block'};
    margin-top: 5.6rem;

    ${MEDIA_QUERIES(theme).medium} {
      display: block;
    }
  `
)

export const SrOnlyHeading = styled.h2`
  border-width: 0;
  clip: rect(0, 0, 0, 0);
  height: 0.1rem;
  margin: -0.1rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 0.1rem;
`

export const CopyrightContainer = styled.div(
  ({ theme }) => `
    font-size: 1.3rem;
    font-weight: normal;
    line-height: 2.2rem;
    color: #c5c6cb;
    margin: 6rem ${theme.spacing.husky} 0;
    padding-bottom: 6rem;
    text-align: center;

    ${MEDIA_QUERIES(theme).mediumSmall} {
      margin-top: 3rem;
    }

    ${MEDIA_QUERIES(theme).medium} {
      margin: 6rem 0 0 0;
    }

    @media print {
      display: none;
    }
  `
)

export const CopyrightSymbol = styled.span`
  font-size: 1.7rem;
  vertical-align: middle;
`

export const CopyrightText = styled.p(
  ({ theme }) => `
    ${MEDIA_QUERIES(theme).medium} {
      margin: 0;
    }
  `
)
